export const BREADCRUMBS_CONTAINER_ID = "chrome-breadcrumb";
export const NAV_ELEMENT_SELECTOR = `#${BREADCRUMBS_CONTAINER_ID} nav`;
